import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import withDnaData from 'src/components/OligoDNA/components/withDnaData';
import { DnaOligo, Email } from 'src/models';

import EmailComponent from './EmailComponent';
import { sendEmailAction } from './action';

const EmailContainer = ({
  dnaData,
  sendEmail
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const onSuccess = () => {
    setIsOpen(false);
  };

  const handleShareOrder = async (emails) => {
    const payloadData = DnaOligo.processApiData(dnaData);

    const fileTypeData = Email.emailPayloadData(dnaData, payloadData);

    const payload = {
      emailAddresses: [...emails],
      ...fileTypeData
    };
    const response = await sendEmail(payload);

    return response;
  };

  return (
    <EmailComponent
      isOpen={isOpen}
      openModal={() => setIsOpen(true)}
      handleClose={() => setIsOpen(false)}
      onSuccess={onSuccess}
      handleShareOrder={handleShareOrder}
    />
  );
};

EmailContainer.propTypes = {
  dnaData: PropTypes.object.isRequired,
  sendEmail: PropTypes.func.isRequired
};

const mapDispatchToProps = ({
  sendEmail: sendEmailAction
});

export default compose(withDnaData, connect(null, mapDispatchToProps))(EmailContainer);
